class PaymentsDatatable {
    constructor(){
        let organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.datatable = this.init('#payments-datatable', organizationID);
    }
    init(el, organizationID){
        const datatable =  $(el).DataTable({
            searchDelay: 400,
            processing: true,
            order: [[0, 'desc']],
            serverSide: true,
            stateSave: false,
            info: true,
            paging: true,
            ajax: {
                url: '?do=getPayments',
                type: 'POST',
                data: {
                    organizationID: organizationID
                }
            },
            language: {
                emptyTable: "No data found"
            },
            dom:
                "<'table-responsive'tr>" +
                "<'row'" +
                "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'li>" +
                "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'p>" +
                ">",
            drawCallback: function(settings) {
                // Remove all visible popovers after datatable draw
                document.querySelectorAll('.popover.fade.show').forEach(function (el) {
                    el.remove();
                });
                // Init all popovers after datatable draw
                const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });
                // init page length select
                $('select[name=payments-datatable_length]').select2({minimumResultsForSearch: -1});
            },
            columns: [
                {
                    data: 'timestamp',
                    title: 'Date',
                    className: 'min-w-90px',
                    sortable: true,
                    render: function (data, type, row) {
                        return `<span data-bs-toggle="popover" data-bs-trigger="hover" data-bs-placement="bottom" data-bs-content="${row['timezone']}">${row['timestamp']}</span>`;
                    }
                },
                {
                    data: 'organizationName',
                    title: 'Team Name',
                    className: 'min-w-100px',
                    sortable: true,
                    render: function (data, type, row) {
                        return '<div class="d-flex">' +
                            '       <span class="d-flex flex-center flex-shrink-0 w-40px me-3">\n' +
                            '           <div class="symbol symbol-circle symbol-35px">\n' +
                            '               <div class="symbol-label fw-bold bg-primary text-inverse-primary">'+(row['organizationName'] ? row['organizationName'].charAt(0).toUpperCase() : '')+'</div>\n' +
                            '           </div>\n' +
                            '       </span>' +
                            '       <div class="d-flex align-items-center"><a href="'+(row['organizationName'] ? row['organizationLink'] : '#')+'" class="text-decoration-underline-ga primary">'+(row['organizationName'] ? row['organizationName'] : '[Archived Team]')+'</a></div>'+
                            '   </div>';
                    }
                },
                {
                    data: 'product',
                    title: 'Product',
                    className: 'min-w-100px',
                    sortable: true,
                    render: function (data, type, row) {
                        return '<span class="text-primary">'+row['product']+'</span>';
                    }
                },
                {
                    data: 'price',
                    title: 'Price',
                    sortable: true,
                    render: function (data, type, row) {
                        if(row['currency'] === '$'){
                            return '<span class="text-primary">$'+row['fullPrice']+'</span>';
                        }
                        return '<span class="text-primary">'+row['fullPrice']+row['currency']+'</span>';
                    }
                },
                {
                    data: 'method',
                    title: 'Method',
                    sortable: true,
                    render: function (data, type, row) {
                        return '<span class="text-primary">'+row['method']+'</span>';
                    }
                },
                {
                    data: null,
                    title: 'Download',
                    sortable: false,
                    render: function (data, type, row) {
                        let html = '<div class="datatable-action min-w-2">'
                            html +=
                                '   <div class="btn btn-icon btn-bg-light btn-sm btn-active-color-primary cursor-pointer download-invoice" id="'+row['paymentID']+'" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="Download Invoice">'+'         <span class="svg-icon svg-icon-1">'+
                                '               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">'+
                                '                    <path opacity="0.3" d="M19 15C20.7 15 22 13.7 22 12C22 10.3 20.7 9 19 9C18.9 9 18.9 9 18.8 9C18.9 8.7 19 8.3 19 8C19 6.3 17.7 5 16 5C15.4 5 14.8 5.2 14.3 5.5C13.4 4 11.8 3 10 3C7.2 3 5 5.2 5 8C5 8.3 5 8.7 5.1 9H5C3.3 9 2 10.3 2 12C2 13.7 3.3 15 5 15H19Z" fill="currentColor"/>'+
                                '                    <path d="M13 17.4V12C13 11.4 12.6 11 12 11C11.4 11 11 11.4 11 12V17.4H13Z" fill="currentColor"/>'+
                                '                    <path opacity="0.3" d="M8 17.4H16L12.7 20.7C12.3 21.1 11.7 21.1 11.3 20.7L8 17.4Z" fill="currentColor"/>'+
                                '                </svg>'+
                                '          </span>' +
                                '   </a>';
                            if(row['creditNotes']){
                                for (let i = 0; i < row['creditNotes'].length; i++){
                                    html +=
                                        '   <div class="btn btn-icon btn-bg-light btn-sm btn-active-color-primary cursor-pointer download-credit-note" id="'+row['creditNotes'][i]+'" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="Download Credit Note">'+'       <span class="svg-icon svg-icon-1">'+
                                        '           <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">'+
                                        '               <path opacity="0.3" d="M19 22H5C4.4 22 4 21.6 4 21V3C4 2.4 4.4 2 5 2H14L20 8V21C20 21.6 19.6 22 19 22ZM12.5 18C12.5 17.4 12.6 17.5 12 17.5H8.5C7.9 17.5 8 17.4 8 18C8 18.6 7.9 18.5 8.5 18.5L12 18C12.6 18 12.5 18.6 12.5 18ZM16.5 13C16.5 12.4 16.6 12.5 16 12.5H8.5C7.9 12.5 8 12.4 8 13C8 13.6 7.9 13.5 8.5 13.5H15.5C16.1 13.5 16.5 13.6 16.5 13ZM12.5 8C12.5 7.4 12.6 7.5 12 7.5H8C7.4 7.5 7.5 7.4 7.5 8C7.5 8.6 7.4 8.5 8 8.5H12C12.6 8.5 12.5 8.6 12.5 8Z" fill="currentColor"/>'+
                                        '               <rect x="7" y="17" width="6" height="2" rx="1" fill="currentColor"/>'+
                                        '               <rect x="7" y="12" width="10" height="2" rx="1" fill="currentColor"/>'+
                                        '               <rect x="7" y="7" width="6" height="2" rx="1" fill="currentColor"/>'+
                                        '               <path d="M15 8H20L14 2V7C14 7.6 14.4 8 15 8Z" fill="currentColor"/>'+
                                        '           </svg>'+
                                        '       </span>' +
                                        '   </div>';
                                }
                            }
                        return html+'</div>';
                    }
                }
            ]
        }).on('init.dt', function () {
            if(datatable.page.info().recordsTotal === 0){
                $('[data-kt-docs-table-toolbar=base]').addClass('d-none');
                $('#payments-datatable_wrapper').hide();
                $('#payments-datatable_no-results').addClass('d-flex flex-center flex-column').removeClass('d-none');
            }
        });
        // Init and add delay to datatable search
        new DatatableSearchDelay(datatable, '[data-kt-docs-table-filter=search]');
        return datatable;
    }
}
window.PaymentsDatatable = PaymentsDatatable;